module.exports = __webpack_public_path__ + "assets/img/W-3-F.78c6c58f.png";